export enum InitialProcessingPart {
    CalcCombos,
    Graph,
    DefaultViewCreation,
}

export class ProcessingProgressDto {
    public projectId: string;
    public aborted: boolean;
    public error: string | null;
    public part: InitialProcessingPart;
    public partPercent: number | null;
}